import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';
// import { Premarticle1Doc } from '../premiumIndividual';

export default function Premarticle1() {


  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article1" headerImage="blackout.jpg" reference="https://www.pexels.com/photo/light-bulb-577514/" photographer="LED Supermarket"/>
        <Footer />
    </div>
  )
}
